export let colorObj = {
  'Inactive time': "#fff",
  "Cool down time": "#7daebc",
  'Unpacking time': "#A1A19D",
  'Setup time': "#B7D5FB",
  'Build time': "#5197F7",
};
